<script setup>
import ModalBase from './ModalBase.vue'
import CalendarPicker from './CalendarPicker.vue'

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: 'Datum kiezen',
    },
    modelValue: {
        type: String,
        default: '',
    },
    maxDate: {
        type: String,
        default: '',
    },
    helpText: {
        type: String,
        default: '',
    },
    autoCloseOnSelect: {
        type: Boolean,
        default: true,
    },
})

const emit = defineEmits(['update:modelValue', 'close'])

const handleSelect = (value) => {
    emit('update:modelValue', value || '')

    if (props.autoCloseOnSelect) {
        emit('close')
    }
}

const handleClear = () => {
    emit('update:modelValue', '')
    emit('close')
}

const handleCancel = () => {
    emit('close')
}
</script>

<template>
    <ModalBase v-if="show" :title="title" @close="emit('close')">
        <template #default>
            <div class="form-stack form-stack-sm">
                <CalendarPicker
                    :model-value="modelValue"
                    :max-date="maxDate || undefined"
                    @update:modelValue="handleSelect"
                />
                <small v-if="helpText" class="muted">{{ helpText }}</small>
            </div>
        </template>
        <template #footer>
            <button class="button button-secondary" type="button" @click="handleCancel">
                Annuleren
            </button>
            <button
                v-if="modelValue"
                class="button button-ghost button--danger-ghost"
                type="button"
                @click="handleClear"
            >
                Datum verwijderen
            </button>
        </template>
    </ModalBase>
</template>
